/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useArticle, useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { formatArticleError } from '@utils';
import { getImage } from '@utils/media';

const Item = ({ className, module, errors }) => {
  const { article, error } = useArticle(module.content.articleId);
  const { media } = useMedia(getImage(module.content));

  let description = module.content.title;

  if (module.content.articleId) {
    description = error ? formatArticleError(error) : article.title || 'loading article...';
  }

  return (
    <InfoItem.WithError size="large" image={media.src} description={description} error={errors}>
      Lifestyle Panel
    </InfoItem.WithError>
  );
};

export default Item;
